// Replacement for vue-crono's `crono` mixin: runs `cron.method` every `cron.time` ms while mounted
export const crono = {
  mounted () {
    const cron = this.$options.cron
    if (!cron) return
    const jobs = Array.isArray(cron) ? cron : [cron]
    this.__cronTimers = jobs.map(job =>
      setInterval(() => {
        const method = this[job.method]
        if (typeof method === 'function') method.call(this)
      }, job.time)
    )
  },
  beforeUnmount () {
    if (this.__cronTimers) this.__cronTimers.forEach(clearInterval)
  }
}
